import Auth from '../services/auth';
import Account from '../services/account';

import lscache from 'lscache';

export default {
  namespaced: true,
  state: {
    user: null,
    token: null,
    shared: false,
    subscription: null,
    authenticated: false,
    error: null
  },
  getters: {
    authenticated: state => !!state.authenticated,
    user: state => state.user,
    subscription: state => state.subscription,
    shared: state => state.shared,
  },
  mutations: {
    setLoggedOut(state) {
      state.user = null;
      state.token = null;
      state.shared = false;
      state.authenticated = false;
    },
    setLoggedIn(state, data) {
      state.user = data.user;
      state.token = data.token;
      state.shared = data.shared || false;
      state.authenticated = data.user !== null && data.user !== undefined && data.token !== null && data.token !== undefined;
    },
    setUser(state, user) {
      state.user = user;
      state.authenticated = user !== null && user !== undefined;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async login({commit, dispatch}, creds) {
      let res = await Auth.login(creds);
      localStorage.removeItem("dailytips");
      dispatch('setLoggedIn', res);
    },
    async logout({commit, dispatch}) {
      await Auth.logout()
      localStorage.removeItem("dailytips");
      dispatch('setLoggedOut');
    },
    async getUser({commit, dispatch}) {
      let res = await Account.user();

      dispatch('setUser', res.data);

    },
    async getSession({commit, dispatch}) {
      let res = await Account.user();

      dispatch('setUser', res.data);

    },
    async updateUser({commit, dispatch}, data) {
      let res = await Account.update(data);

      dispatch('setUser', res.data);
    },
    async cancelAccount({commit, dispatch}) {
      await Account.cancel();

      dispatch('setLoggedOut');
    },
    async init({commit, dispatch}) {
      if (lscache.get('session')) {
        commit('setLoggedIn', lscache.get('session'))
      }
    },
    async checkin({commit, dispatch}) {
      try {
        let res = await Account.user();

        dispatch('setUser', res.data);
      } catch (err) {
        dispatch('setLoggedOut');
      }
    },
    async swapSubscription({commit, dispatch}, userType) {
      let res = await Account.swapSubscription({type: userType});

      dispatch('setUser', res.data);
    },
    async resumeSubscription({commit, dispatch}) {
      let res = await Account.resumeSubscription();

      dispatch('setUser', res.data);
    },
    async subscribe({commit, dispatch}, params) {
      let res = await Account.subscribe(params);

      dispatch('setUser', res.data);
    },
    async cancelSubscription({commit, dispatch}) {
      let res = await Account.cancelSubscription();

      dispatch('setUser', res.data);
    },
    async updatePaymentInfo({commit, dispatch}, params) {
      let res = await Account.updatePaymentInfo(params);

      dispatch('setUser', res.data);
    },
    setUser({commit}, data) {
      lscache.set('session', data);
      commit('setUser', data);
    },
    setLoggedIn({commit}, data) {
      lscache.set('session', data);
      commit('setLoggedIn', data);
    },
    setLoggedOut({commit}) {
      lscache.remove('session');
      commit('setLoggedOut');
    }
  }
}
